<template>
  <div class="loader">{{$t('loader.Loading')}}...</div>
</template>
